import React from 'react';

import { useMREState } from '../../hooks/useMREState';

interface HideWhenFlyoverActiveProps {
  children: React.ReactNode;
}

export const HideWhenFlyoverActive = ({
  children
}: HideWhenFlyoverActiveProps) => {
  const { isFlyoverInProgress } = useMREState();
  return isFlyoverInProgress ? null : <>{children}</>;
};
